import context from '../context'
import { actionCreators as dialogActions } from './Dialogs'
import { dialogTypes } from '@/dialogs'
import { fromUtcDate } from '@/utils/dateUtilities'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  generating: false,
  deleting: false,
  tokens: []
}

export const actionTypes = {
  Fetching: 'personalAccessTokens/fetching',
  Fetched: 'personalAccessTokens/fetched',
  Deleting: 'personalAccessTokens/deleting',
  Deleted: 'personalAccessTokens/deleted',
  Generating: 'personalAccessTokens/generating',
  Generated: 'personalAccessTokens/generated',
  Error: 'personalAccessTokens/error'
}

export const actionCreators = {
  getAll: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.userProfile.getAllPersonalAccessTokens(allowErrorDialog)
      .then(result => {
        dispatch({ type: actionTypes.Fetched, data: result.map(x => ({ ...x, validTo: fromUtcDate(x.validTo) })) })
      })
      .catch(() => dispatch({ type: actionTypes.Error, update: { fetching: false } }))
  },
  generatePersonalAccessToken: (name, validityInDays) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Generating })
    context.api.userProfile.generatePersonalAccessToken({ name, validityInDays }, allowErrorDialog)
      .then(result => {
        dispatch({ type: actionTypes.Generated })
        dispatch(dialogActions.openDialog({
          dialogType: dialogTypes.generatedPatToken,
          token: result.token
        }))
        dispatch(actionCreators.getAll())
      })
      .catch(() => dispatch({ type: actionTypes.Error, update: { generating: false } }))
  },
  deletePersonalAccessToken: (input) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Deleting })
    context.api.userProfile.deletePersonalAccessToken(input, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.Deleted, data: input })
      })
      .catch(() => dispatch({ type: actionTypes.Error, update: { deleting: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, tokens: action.data }
    case actionTypes.Deleting: return { ...state, deleting: true }
    case actionTypes.Deleted: return { ...state, deleting: false, tokens: state.tokens.filter(token => token.id !== action.data.id) }
    case actionTypes.Generating: return { ...state, generating: true }
    case actionTypes.Generated: return { ...state, generating: false }
    case actionTypes.Error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/PersonalAccessTokens.js